import {AbstractUpload} from "./AbstractUpload";
import {Injectable} from "@angular/core";
import {Local} from "../../../domain/Local";
import {LocalHttpService} from "../../persist/http/LocalHttpService";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {EnumSincronizacao} from "../../../domain/EnumSincronizacao";

@Injectable()
export class UploadLocal extends AbstractUpload<Local>{
  constructor(service: LocalHttpService) {
    super("Local", service, Local);
  }

  override async getPendencias(): Promise<any[]>{
    const repo = LocalDataSource.getRepository(Local)
    const locais = await repo.find({
      where: {situacao: EnumSincronizacao.ENVIAR},
      relations: ["pai"]
    })
    locais.forEach(l=> l.pai = l.pai?.id as any)
    console.log('locais', locais)
    return locais
  }
}
